const initialState = {
  loading: false,
  resources: [],
  error: null,
  saving: false,
  selectedResource: null,
};

const resourcesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_RESOURCES_REQUEST":
      return { ...state, loading: true, error: null };

    case "FETCH_RESOURCES_SUCCESS":
      return { ...state, loading: false, resources: action.payload || [] };

    case "FETCH_RESOURCES_FAILURE":
      return { ...state, loading: false, error: action.payload };

      case "SAVE_RESOURCE_SUCCESS":
        return {
          ...state,
          saving: false,
          resources: Array.isArray(state.resources)
            ? [...state.resources, action.payload]
            : [action.payload],
          error: null,
        };
      

    case "DELETE_RESOURCE_SUCCESS":
      return {
        ...state,
        resources: state.resources.filter(
          (r) => r.resourceObjId !== action.payload.resourceObjId
        ),
      };

    case "UPDATE_RESOURCE_SUCCESS":
      return {
        ...state,
        resources: state.resources.map((r) =>
          r.resourceObjId === action.payload.resourceObjId
            ? action.payload
            : r
        ),
      };

    case "FETCH_RESOURCE_BY_ID_SUCCESS":
      return { ...state, selectedResource: action.payload };

    default:
      return state;
  }
};

export default resourcesReducer;
